export const getVar = color => {
  return window.getComputedStyle(document.body).getPropertyValue(color);
};
